import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from '../../api/api'

export default function Employee() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [datafilter, setDatafilter] = useState([])
    const [searchParams, setSearchParams] = useSearchParams()

    // const [name, setName] = useState('')
    // const [page, setPage] = React.useState(1);
    let name = searchParams.get('name') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`employees`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [])
    useEffect(() => {
        let item = data.filter(x => (
            (
                x.Fname.toLocaleLowerCase().indexOf((name) ? name.toLowerCase() : '') > -1) ||
            x.Lname.toLocaleLowerCase().indexOf((name) ? name.toLowerCase() : '') > -1 ||
            x.Email.toLocaleLowerCase().indexOf((name) ? name.toLowerCase() : '') > -1 ||
            x.Tel.toLocaleLowerCase().indexOf((name) ? name.toLowerCase() : '') > -1
        )
        );
        setDatafilter(item)
    }, [name])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการผู้ใช้งานระบบ
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">
                        <Link to='/setting/employee/add'>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>

                        </Link>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={name} onChange={e => setSearchParams({ name: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา รหัส / ชื่อ"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="listData row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>

                                <tr>
                                    <th class="text-center" >ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center" >รหัสผู้ใช้งาน</th>
                                    <th class="text-center">ชื่อ</th>
                                    <th class="text-center" >นามสกุล</th>
                                    <th class="text-center">ตำแหน่ง</th>
                                    <th class="text-center">อีเมล</th>
                                    <th class="text-center">เบอร์โทรศัพท์</th>
                                    <th class="text-center" >สถานะ</th>
                                    <th class="text-center" ></th>

                                </tr>
                            </thead>
                            <tbody class="cp">
                                {datafilter.length === 0 ? data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                    <tr style={{ cursor: "pointer" }} onClick={() => navigate(`/setting/employee/${x?.UserLogin}`)}>
                                        <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                        <td class="text-center">{x?.EmpNo}</td>
                                        <td class="text-center">{x?.Fname}</td>
                                        <td class="text-center">{x?.Lname}</td>
                                        <td class="text-center">{x?.RoleId?.RoleName}</td>
                                        <td class="text-center">{x?.Email}</td>
                                        <td class="text-center">{x?.Tel}</td>
                                        <td class="text-center">
                                            {
                                                x?.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span> :
                                                    <span class="status-inactive">
                                                        ไม่ใช้งาน
                                                    </span>}
                                        </td>
                                    </tr>
                                )) : datafilter?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                    <tr className={id === x?.UserLogin ? 'active' : ''}>
                                        <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                        <td class="text-center">{x?.EmpNo}</td>
                                        <td class="text-center">{x?.Fname}</td>
                                        <td class="text-center">{x?.Lname}</td>
                                        <td class="text-center">{x?.RoleId?.RoleName}</td>
                                        <td class="text-center">{x?.Email}</td>
                                        <td class="text-center">{x?.Tel}</td>
                                        <td class="text-center">
                                            {
                                                x?.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span> :
                                                    <span class="status-inactive">
                                                        ไม่ใช้งาน
                                                    </span>}
                                        </td>
                                        <td class="text-center">
                                            <Link to={`/setting/employee/${x?.UserLogin}`} onClick={() => setSearchParams({ id: x?.UserLogin, page: page, name: name, })}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, name: name, id: id })} shape="rounded" />
                    </div >
                </div >
            </div >
        </Page >
    )
}
